"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackMiddleware = exports.trackDecorator = exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @getValue
 *
 * Get object value from stringify path.
 */
var getValue = function getValue(obj, key) {
  return key.split('.').reduce(function (o, k) {
    return !o ? o : o[k];
  }, obj);
};
/**
 * @Tracker
 *
 * Singleton for tracking functionalities pulling GTM to enable
 * redirect and interaction.
 */
var Tracker = /*#__PURE__*/function () {
  function Tracker() {
    (0, _classCallCheck2.default)(this, Tracker);
    (0, _defineProperty2.default)(this, "tracks", {});
    var isDOM = typeof window !== 'undefined' && !!window.document;

    // TODO: Remove this block if it is never logged in production
    if (isDOM && !window.dataLayer && window.parent.dataLayer) {
      var _window$DD_RUM, _window$DD_RUM$getIni;
      window.DD_RUM && ((_window$DD_RUM = window.DD_RUM) === null || _window$DD_RUM === void 0 ? void 0 : (_window$DD_RUM$getIni = _window$DD_RUM.getInitConfiguration()) === null || _window$DD_RUM$getIni === void 0 ? void 0 : _window$DD_RUM$getIni.clientToken) !== 'undefined' && window.DD_RUM.addRumError('Parent dataLayer is used - message FE devs', {
        location: window.location,
        parentLocation: window.parent.location
      });
    }
    this.dataLayer = isDOM && window.dataLayer || [];
  }
  return (0, _createClass2.default)(Tracker, [{
    key: "hasTrack",
    value: function hasTrack(name) {
      return !!this.tracks[name];
    }
  }, {
    key: "addTrack",
    value: function addTrack(name, data) {
      this.tracks[name] = data;
    }
  }, {
    key: "removeTrack",
    value: function removeTrack(name) {
      this.hasTrack(name) && delete this.tracks[name];
    }
  }, {
    key: "getTracks",
    value: function getTracks() {
      return this.tracks;
    }
  }, {
    key: "setTracks",
    value: function setTracks(tracks) {
      this.tracks = tracks;
    }
  }, {
    key: "interaction",
    value: function interaction(name, data) {
      var track = this.tracks[name];
      track && this.dataLayer.push(!data ? track : _objectSpread(_objectSpread({}, track), data));
    }
  }, {
    key: "redirect",
    value: function redirect(name, url, data) {
      var track = this.tracks[name];
      url && setTimeout(window.location.replace, 2000, url);
      track && this.dataLayer.push(!data ? _objectSpread(_objectSpread({}, track), {}, {
        url: url
      }) : _objectSpread(_objectSpread({}, track), {}, {
        url: url
      }, data));
    }
  }]);
}();
/**
 * @tracker
 *
 * Tracker singleton, only tracker will be exported as default.
 */
var tracker = new Tracker();

/**
 * @trackMiddleware
 *
 * Tracker helper available from the import, to be added on the redux
 * applyMiddleware function. It will listen for matching action/track.
 *
 * applyMiddleware(trackMiddleware)
 */
var trackMiddleware = exports.trackMiddleware = function trackMiddleware(store) {
  return function (next) {
    return function (action) {
      try {
        var trackName = action.type;
        var state = store.getState();
        var trackData = tracker.tracks[trackName];
        if (tracker.hasTrack(trackName)) {
          for (var _key in trackData) {
            if (Object.prototype.hasOwnProperty.call(trackData, _key) && typeof trackData[_key] === 'string') {
              trackData[_key] = getValue(state, trackData[_key]);
            }
          }
        }
        tracker.interaction(trackName, trackData);
      } catch (error) {
        /**
         * Safe middleware to prevent any error blocking the application.
         * console.error(error);
         */
      }
      return next(action);
    };
  };
};

/**
  method decorator: @trackDecorator
 
  Tracker helper available from the import, to be added on a class
  method. It will listen for matching param/track.
 
  @trackDecorator('CLICK_TRACK', { ...data? })
  handleClick() {
    ...
  }
 */
var trackDecorator = exports.trackDecorator = function trackDecorator(trackName, trackData) {
  return function (target, name, descriptor) {
    var original = descriptor.value;
    // eslint-disable-next-line
    descriptor.value = function () {
      for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }
      original.apply(this, args);
      tracker.interaction(trackName, trackData);
    };
    return descriptor;
  };
};
var _default = exports.default = tracker;